const assetCategoryLabels: Record<string, string> = {
  STOCK: 'Ações',
  FII: 'Fundos imobiliários',
  FIAGRO: 'Fiagros',
  ETF: 'ETFs',
  BDR: 'BDRs',
  FIXED_INCOME: 'Renda fixa',
  TREASURY: 'Tesouro Direto',
  LOAN: 'Empréstimos',
  CASH: 'Caixa',
  OTHER: 'Outros investimentos',
};

export const getPortfolioAssetCategoryLabel = (category: string) =>
  assetCategoryLabels[category] ?? category;
